import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useTranslationData = () => {
    const { t } = useTranslation();

    const getValidationMessageTranslate = useCallback(
        (path: string) => {
            const base = 'stisPublications:validationMessage';
            return t(`${base}.${path}`);
        },
        [t]
    );

    const validationMessageDataTranslate = useMemo(() => {
        const data = {
            title: getValidationMessageTranslate('title'),
            publicationType: getValidationMessageTranslate('publicationType'),
            docCode: getValidationMessageTranslate('docCode'),
            visibilityType: getValidationMessageTranslate('visibilityType'),
            contentURL: getValidationMessageTranslate('contentURL'),
            description: getValidationMessageTranslate('previewDescription'),
            contentFile: getValidationMessageTranslate('contentFile'),
            contentFileZip: getValidationMessageTranslate('contentFileZip'),
            publishedYear: getValidationMessageTranslate('publishedYear'),
            publishedMonth: getValidationMessageTranslate('publishedMonth'),
        };
        return data;
    }, [getValidationMessageTranslate]);

    return { validationMessageDataTranslate };
};

export default useTranslationData;
